/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProxyRequest
 */
export interface UpdateProxyRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateProxyRequest
     */
    proxyId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProxyRequest
     */
    proxyUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProxyRequest
     */
    proxyName?: string | null;
}

/**
 * Check if a given object implements the UpdateProxyRequest interface.
 */
export function instanceOfUpdateProxyRequest(value: object): value is UpdateProxyRequest {
    if (!('proxyId' in value) || value['proxyId'] === undefined) return false;
    return true;
}

export function UpdateProxyRequestFromJSON(json: any): UpdateProxyRequest {
    return UpdateProxyRequestFromJSONTyped(json, false);
}

export function UpdateProxyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProxyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'proxyId': json['proxy_id'],
        'proxyUrl': json['proxy_url'] == null ? undefined : json['proxy_url'],
        'proxyName': json['proxy_name'] == null ? undefined : json['proxy_name'],
    };
}

export function UpdateProxyRequestToJSON(json: any): UpdateProxyRequest {
    return UpdateProxyRequestToJSONTyped(json, false);
}

export function UpdateProxyRequestToJSONTyped(value?: UpdateProxyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proxy_id': value['proxyId'],
        'proxy_url': value['proxyUrl'],
        'proxy_name': value['proxyName'],
    };
}

